import Loadable from 'pages/Groups/Loadable';
import reducer from './modules/groups.slice';
import saga from 'containers/App/modules/entities/groups/groupEntity.saga'

export default {
	component: Loadable,
	saga,
	reducer
};